/**
 * 后台角色API
 */
import { fetch, post, del, postForm } from 'api/base/axios';

const URL = {
  checkPhoneUrl: '/user/register/cellphone/exist/',
  sendSmsUrl: '/user/register/sms_code/',
  registerUserUrl: '/user/register/signup/',
  getSmsCheck: '/user/register/sms_check/'
};

export function checkPhoneExist (cellphone) {
  return fetch(URL.checkPhoneUrl + cellphone + "/");
}

export function getSmsCheck () {
  return fetch(URL.getSmsCheck);
}

export function SendSms (cellphone, sms_key, captcha_text) {
  const params = {
    cellphone
  }

  if(sms_key) {
    params.sms_key = sms_key,
    params.captcha_text = captcha_text 
  }
  
  return fetch(URL.sendSmsUrl, params);
}

export function RegisterUser (form) {
  return post(URL.registerUserUrl, form);
}
